/* Product photo gallery (Aleksandra 1.10, 1:1 her preview "Batida_galeria_produktu"). Data: #v7g-data
   (snippets/batida-v7-pgal.liquid). A click on the big photo (not a drag of the slideshow) opens the photos full screen on
   a dark background at the photo selected on the page. Sideways: swipe (phones), ‹ › or ← → (computers); thumbnails
   at the bottom (click = jump), counter "2 / 5" at the top. Close: ×, Esc or a click on the dark background; the page
   then shows the photo viewed last (its thumbnail, else its dot). No zoom, no magnifier. */
(function () {
  var dataEl = document.getElementById('v7g-data');
  var show = document.querySelector('[data-product-slideshow]');
  if (!dataEl || !show) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var P = data.items || [];
  if (!P.length) return;

  var L = {
    pl: ['Zdjęcia produktu', 'Zamknij', 'Poprzednie zdjęcie', 'Następne zdjęcie', 'Zdjęcie'],
    en: ['Product photos', 'Close', 'Previous photo', 'Next photo', 'Photo'],
    de: ['Produktfotos', 'Schließen', 'Vorheriges Foto', 'Nächstes Foto', 'Foto'],
    fr: ['Photos du produit', 'Fermer', 'Photo précédente', 'Photo suivante', 'Photo'],
    uk: ['Фото товару', 'Закрити', 'Попереднє фото', 'Наступне фото', 'Фото']
  };
  var T = L[(document.documentElement.lang || 'pl').slice(0, 2)] || L.pl;
  var byId = {};
  P.forEach(function (it, i) { byId[String(it.id)] = i; });

  var lb, track, count, pv, nx, ths, cur = 0, lastFocus = null;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function small() { return window.innerWidth < 861; }

  function build() {
    lb = document.createElement('div');
    lb.className = 'v7g' + (P.length < 2 ? ' is-single' : '');
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', T[0] + ': ' + (data.title || ''));
    lb.innerHTML =
      '<div class="v7g__top"><span class="v7g__count" aria-live="polite"></span>' +
      '<button type="button" class="v7g__x" aria-label="' + esc(T[1]) + '">&times;</button></div>' +
      '<div class="v7g__track">' + P.map(function (it) {
        return '<div class="v7g__slide"><img src="' + esc(small() ? it.mid : it.src) + '" alt="' + esc(it.alt) + '" loading="lazy" draggable="false"></div>';
      }).join('') + '</div>' +
      '<button type="button" class="v7g__nav v7g__nav--prev" aria-label="' + esc(T[2]) + '">&lsaquo;</button>' +
      '<button type="button" class="v7g__nav v7g__nav--next" aria-label="' + esc(T[3]) + '">&rsaquo;</button>' +
      '<div class="v7g__thumbs">' + P.map(function (it, i) {
        return '<button type="button" class="v7g__th" data-i="' + i + '" aria-label="' + esc(T[4] + ' ' + (i + 1)) + '"><img src="' + esc(it.thumb) + '" alt="' + esc(it.alt) + '" draggable="false"></button>';
      }).join('') + '</div>';
    document.body.appendChild(lb);
    track = lb.querySelector('.v7g__track');
    count = lb.querySelector('.v7g__count');
    pv = lb.querySelector('.v7g__nav--prev');
    nx = lb.querySelector('.v7g__nav--next');
    ths = [].slice.call(lb.querySelectorAll('.v7g__th'));
    pv.onclick = function () { go(cur - 1); };
    nx.onclick = function () { go(cur + 1); };
    lb.querySelector('.v7g__x').onclick = close;
    ths.forEach(function (b) { b.onclick = function () { go(+b.getAttribute('data-i')); }; });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
      if (i !== cur) setLb(i);
    }, { passive: true });
    track.addEventListener('click', function (e) { if (e.target.classList.contains('v7g__slide')) close(); });
    window.addEventListener('resize', function () { if (!lb.hidden) go(cur, false); }, { passive: true });
  }

  function setLb(i) {
    cur = i;
    count.textContent = (i + 1) + ' / ' + P.length;
    pv.disabled = i === 0;
    nx.disabled = i === P.length - 1;
    ths.forEach(function (b, j) { if (j === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    var tb = ths[i];
    if (tb && tb.parentNode.scrollWidth > tb.parentNode.clientWidth) {
      tb.parentNode.scrollTo({ left: tb.offsetLeft - (tb.parentNode.clientWidth - tb.offsetWidth) / 2, behavior: 'smooth' });
    }
  }
  function go(i, smooth) {
    i = Math.max(0, Math.min(P.length - 1, i));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false || reduce ? 'auto' : 'smooth' });
    setLb(i);
  }

  function open(i) {
    if (!lb || !document.body.contains(lb)) build();
    lastFocus = document.activeElement;
    lb.hidden = false;
    document.documentElement.classList.add('v7g-open');
    cur = i;
    requestAnimationFrame(function () { go(i, false); });
    document.addEventListener('keydown', onKey, true);
    setTimeout(function () { var x = lb.querySelector('.v7g__x'); if (x) x.focus({ preventScroll: true }); }, 30);
  }

  function selectOnPage(i) {
    var id = String(P[i].id);
    var th = document.querySelector('[data-media-select="' + id + '"]');
    if (th) { th.click(); return; }
    var slides = [].slice.call(show.querySelectorAll('.product__media[data-media-id]'));
    var k = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === id; });
    var dot = k >= 0 && show.parentNode && show.parentNode.querySelectorAll('.flickity-page-dots .dot, .flickity-page-dot')[k];
    if (dot) dot.click();
  }

  function close() {
    if (!lb || lb.hidden) return;
    lb.hidden = true;
    document.documentElement.classList.remove('v7g-open');
    document.removeEventListener('keydown', onKey, true);
    selectOnPage(cur);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    else if (e.key === 'Tab') {
      var f = [].slice.call(lb.querySelectorAll('button')).filter(function (b) { return b.offsetParent !== null && !b.disabled; });
      if (!f.length) return;
      var a = document.activeElement, first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (a === first || !lb.contains(a))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || !lb.contains(a))) { e.preventDefault(); first.focus(); }
    }
  }

  /* open on a click (not a drag) on an image slide; the theme's zoom never runs on batida.pl */
  var px = 0, py = 0;
  show.addEventListener('pointerdown', function (e) { px = e.clientX; py = e.clientY; }, true);
  document.addEventListener('click', function (e) {
    var slide = e.target.closest && e.target.closest('[data-product-slideshow] .product__media[data-media-id]');
    if (!slide) return;
    if (e.target.closest('[data-zoom-button]')) { e.preventDefault(); e.stopPropagation(); }
    if (slide.getAttribute('data-type') && slide.getAttribute('data-type') !== 'image') return;
    if (e.target.closest('a, button:not([data-zoom-button]), input, select, textarea, video, model-viewer')) return;
    if (Math.abs(e.clientX - px) > 8 || Math.abs(e.clientY - py) > 8) return;
    var i = byId[String(slide.getAttribute('data-media-id'))];
    if (i == null) return;
    e.preventDefault();
    e.stopPropagation();
    open(i);
  }, true);
})();

/* 1.10 (Pat): phones - each photo is as wide as the screen (assets/batida-v7-pgal.css), so dots under it show there are more */
(function () {
  if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) return;
  function setup() {
    var grid = document.querySelector('.product__mobile--carousel .product__grid--slides');
    if (!grid || grid.getAttribute('data-v7-dots')) return;
    var items = [].filter.call(grid.querySelectorAll('.product__media'), function (m) { return !m.classList.contains('hide') && m.offsetWidth; });
    if (items.length < 2) return;
    grid.setAttribute('data-v7-dots', '1');
    var bar = document.createElement('div');
    bar.className = 'v7-pdots'; bar.setAttribute('aria-hidden', 'true');
    items.forEach(function () { bar.appendChild(document.createElement('span')); });
    grid.parentNode.insertBefore(bar, grid.nextSibling);
    // Pipeline's slider (Flickity) marks the photo in view with .is-selected and moves them with a transform; without it the
    // strip scrolls natively. Both are followed.
    function upd() {
      var i = -1;
      items.forEach(function (m, k) { if (i < 0 && m.classList.contains('is-selected')) i = k; });
      if (i < 0) i = Math.round(grid.scrollLeft / (grid.clientWidth || 1));
      [].forEach.call(bar.children, function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    grid.addEventListener('scroll', upd, { passive: true });
    if (window.MutationObserver) new MutationObserver(upd).observe(grid, { subtree: true, attributes: true, attributeFilter: ['class'] });
    upd();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(setup, 300); }); else setTimeout(setup, 300);
})();

